import { render, staticRenderFns } from "./MenuBox.vue?vue&type=template&id=bdb554a8&scoped=true&"
import script from "./MenuBox.vue?vue&type=script&lang=js&"
export * from "./MenuBox.vue?vue&type=script&lang=js&"
import style0 from "./MenuBox.vue?vue&type=style&index=0&id=bdb554a8&prod&lang=scss&scoped=true&"
import style1 from "./MenuBox.vue?vue&type=style&index=1&id=bdb554a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb554a8",
  null
  
)

export default component.exports